export default "__VITE_ASSET__BLI4jwMM__"